import { store } from "@/redux/store";
import { postLog } from "./logs";

/**
 * Tracking do aviso de nova versão. A detecção e a barra ficam no index.html
 * (rodam antes do React); ele enfileira os eventos em
 * `window.__sysigrejaNovaVersaoEventos` e avisa com `sysigreja:nova-versao`.
 * A aplicação acontece num reload, então ela é registrada em sessionStorage e
 * enviada no carregamento seguinte.
 */

type EventoNovaVersao = {
  acao: string;
  origem?: string;
  versaoAtual?: string | null;
  versaoAnterior?: string | null;
  versaoNova?: string | null;
};

declare global {
  interface Window {
    __sysigrejaNovaVersaoEventos?: EventoNovaVersao[];
  }
}

const NOVA_VERSAO_APLICADA_KEY = "sysigreja_nova_versao_aplicada";

const TIPO_POR_ACAO: Record<string, string> = {
  exibiu_aviso: "Sistema_Exibiu_AvisoNovaVersao",
  adiou: "Sistema_Adiou_NovaVersao",
  aplicou: "Sistema_Aplicou_NovaVersao",
};

const fila: EventoNovaVersao[] = [];

function temSessaoParaLog(): boolean {
  const state = store.getState();
  return Boolean(state.authReducer?.id && state.generalReducer?.LoginId);
}

function enviarFila() {
  if (!temSessaoParaLog()) return;
  while (fila.length > 0) {
    const evento = fila.shift()!;
    const tipo = TIPO_POR_ACAO[evento.acao];
    if (!tipo) continue;
    void postLog({ Tipo: tipo, Objeto: { ...evento } }).catch(() => undefined);
  }
}

function drenarEventosDoIndex() {
  const pendentes = window.__sysigrejaNovaVersaoEventos;
  if (!pendentes?.length) return;
  fila.push(...pendentes.splice(0));
  enviarFila();
}

function lerVersaoAplicadaNoReload() {
  try {
    const bruto = sessionStorage.getItem(NOVA_VERSAO_APLICADA_KEY);
    if (!bruto) return;
    sessionStorage.removeItem(NOVA_VERSAO_APLICADA_KEY);
    const aplicada = JSON.parse(bruto) as Omit<EventoNovaVersao, "acao">;
    fila.push({ ...aplicada, acao: "aplicou" });
  } catch {
    // sessionStorage indisponível ou valor corrompido: só perde o log.
  }
}

export function iniciarTrackingNovaVersao() {
  lerVersaoAplicadaNoReload();
  drenarEventosDoIndex();
  window.addEventListener("sysigreja:nova-versao", drenarEventosDoIndex);
  // A sessão (LoginId) pode chegar depois do boot; envia o que ficou na fila.
  store.subscribe(() => {
    if (fila.length > 0) enviarFila();
  });
}
